import React, { useState } from 'react';
import BlogsSlider from 'components/LandingPageCarousels/BlogsSlider';
import Styles from './styles.js';

const Blogs = ({ bg, residentBlog }) => {
  const [showBlog, setshowBlog] = useState('all-posts');

  return (
    <>
      {residentBlog ? (
        <div
          className="w-full py-6 m-0 blog_section  "
          style={{
            backgroundColor: '#161616',
          }}>
          <div className="container mx-auto">
            <div className="  pb-6">
              <div className=" mb-2  pt-4">
                <h3
                  className="uppercase  fw-400  text-center "
                  style={{ fontFamily: 'Fjalla One', color: '#ffffff', fontSize:'48px' }}>
                  RESIDENT'S BLOG
                </h3>
              </div>
            </div>

            <div className="container mx-auto px-6 lg:px-4 xl:px-3  fs-16-18 text-center " style={{ fontFamily: 'Josefin Sans' }}>
              <div className="row">
                <div className="flex flex-col  lg:flex-row justify-center ">
                  <div className="">
                    <a
                      onClick={() => {
                        setshowBlog('all-posts');
                      }}
                      className="blog_link ">
                      All Posts
                    </a>
                    <a
                      onClick={() => {
                        setshowBlog('Affordability');
                      }}
                      className="blog_link px-3">
                      Affordability
                    </a>
                  </div>

                  <div className="">
                    <a
                      onClick={() => {
                        setshowBlog('Collaboration');
                      }}
                      className="blog_link  ">
                      Collaboration
                    </a>

                    <a
                      onClick={() => {
                        setshowBlog('Environment');
                      }}
                      className="blog_link  px-3">
                      Environment
                    </a>
                  </div>

                  <div className="">
                    <a
                      onClick={() => {
                        setshowBlog('People @ SoulRooms');
                      }}
                      className="blog_link   ">
                      People @ SoulRooms
                    </a>
                    <a
                      onClick={() => {
                        setshowBlog('Roommates');
                      }}
                      className="blog_link px-3">
                      Roommates
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {showBlog == 'all-posts' ? (
              <BlogsSlider />
            ) : showBlog == 'Affordability' ? (
              <div className="flex justify-center py-12">
                <div
                  className="card border-none  lg:pb-6 md:pb-1 pb-3 p-0 
               px-0 flex flex-col justify-center items-center
               rounded-0 text-center"
                  style={{ width: '257px' }}>
                  <div
                    className="blog3 w-full "
                    style={{
                      background: `linear-gradient(rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.24) 100%)
                       , url(${'/static/images/landingPages/blog1.png'})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}></div>
                  <div className="flex flex-col md:px-0 px-4 lg:px-4 bg-white">
                    <p
                      className="m-0 pt-2 fs-14-16"
                      style={{
                        fontFamily: 'josefin Sans',
                        color: '#595959',
                      }}>
                      July 6, 2020
                    </p>
                    <p
                      className="  overflow-hidden pt-0 m-0 lh-27  fs-22-24"
                      style={{
                        height: '109px',
                        fontFamily: 'josefin Sans',
                        color: '#1b1b1b',
                      }}>
                      Let &apos;s talk about Toronto rent
                    </p>
                    <div
                      className="flex justify-center mb-4
                    items-center md:pt-4 lg:pt-3 pt-2 lg:mt-0">
                      <a
                        href={
                          'https://medium.com/soulrooms-inc/lets-talk-about-toronto-rent-2774e010876f?source=rss----c8cd082290c1---4'
                        }
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none  link-warning fs-16-16 "
                        style={{
                          fontFamily: 'josefin Sans',
                          fontSize: '18px',
                          color: '#946F00',
                        }}>
                        Continue Reading
                      </a>
                      <svg
                        viewBox="0 0 24 24"
                        fill="#946F00"
                        width="1em"
                        height="1em"
                        data-ux="Icon"
                        data-aid="chevronRight"
                        className="x-el x-el-svg  link-warning fs-16-16">
                        <path
                          fillRule="evenodd"
                          d="M7.236 4.195a.773.773 0 0 1
                          1.06.031l7.743 7.883-7.742 7.42a.773.773 0
                           0 1-1.06 0 .697.697 0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
                            0 0 1 .032-1.016"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ) : showBlog == 'Collaboration' ? (
              <div className="flex justify-center py-12">
                <div
                  className="card border-none  lg:pb-6 md:pb-1 pb-3 p-0 
              px-0 flex flex-col justify-center items-center
              rounded-0 text-center"
                  style={{ width: '257px' }}>
                  <div
                    className="blog3 w-full "
                    style={{
                      background: `linear-gradient(rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.24) 100%)
                      , url(${'/static/images/landingPages/blog3.png'})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}></div>
                  <div className="flex flex-col md:px-0 px-4 lg:px-4 bg-white">
                    <p
                      className="m-0 pt-2 fs-14-16"
                      style={{
                        fontFamily: 'josefin Sans',
                        color: '#595959',
                      }}>
                      June, 20, 2020
                    </p>
                    <p
                      className="  overflow-hidden pt-0 m-0 lh-27  fs-22-24"
                      style={{
                        height: '109px',
                        fontFamily: 'josefin Sans',
                        color: '#1b1b1b',
                      }}>
                      Can co-living create the next big idea?
                    </p>
                    <div
                      className="flex justify-center mb-4
                   items-center md:pt-4 lg:pt-3 pt-2 lg:mt-0">
                      <a
                        href={'https://medium.com/soulrooms-inc/f-can-co-living-create-the-next-big-idea-73bc969430cf'}
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none  link-warning fs-16-16 "
                        style={{
                          fontFamily: 'josefin Sans',
                          fontSize: '18px',
                          color: '#946F00',
                        }}>
                        Continue Reading
                      </a>
                      <svg
                        viewBox="0 0 24 24"
                        fill="#946F00"
                        width="1em"
                        height="1em"
                        data-ux="Icon"
                        data-aid="chevronRight"
                        className="x-el x-el-svg  link-warning fs-16-16">
                        <path
                          fillRule="evenodd"
                          d="M7.236 4.195a.773.773 0 0 1
                         1.06.031l7.743 7.883-7.742 7.42a.773.773 0
                          0 1-1.06 0 .697.697 0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
                           0 0 1 .032-1.016"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ) : showBlog == 'Environment' ? (
              <div className="flex justify-center py-12">
                <div
                  className="card border-none  lg:pb-6 md:pb-1 pb-3 p-0 
             px-0 flex flex-col justify-center items-center
             rounded-0 text-center"
                  style={{ width: '257px' }}>
                  <div
                    className="blog3 w-full "
                    style={{
                      background: `linear-gradient(rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.24) 100%)
                     , url(${'/static/images/landingPages/blog2.png'})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}></div>
                  <div className="flex flex-col md:px-0 px-4 lg:px-4 bg-white">
                    <p
                      className="m-0 pt-2 fs-14-16"
                      style={{
                        fontFamily: 'josefin Sans',
                        color: '#595959',
                      }}>
                      June, 28, 2020
                    </p>
                    <p
                      className="  overflow-hidden pt-0 m-0 lh-27  fs-22-24"
                      style={{
                        height: '109px',
                        fontFamily: 'josefin Sans',
                        color: '#1b1b1b',
                      }}>
                      Want to support the enviourment?Try co-living.
                    </p>
                    <div
                      className="flex justify-center mb-4
                  items-center md:pt-4 lg:pt-3 pt-2 lg:mt-0">
                      <a
                        href={
                          'https://medium.com/soulrooms-inc/f-we-all-hear-about-climate-change-on-the-news-from-your-friends-a636c47eab60'
                        }
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none  link-warning fs-16-16 "
                        style={{
                          fontFamily: 'josefin Sans',
                          fontSize: '18px',
                          color: '#946F00',
                        }}>
                        Continue Reading
                      </a>
                      <svg
                        viewBox="0 0 24 24"
                        fill="#946F00"
                        width="1em"
                        height="1em"
                        data-ux="Icon"
                        data-aid="chevronRight"
                        className="x-el x-el-svg  link-warning fs-16-16">
                        <path
                          fillRule="evenodd"
                          d="M7.236 4.195a.773.773 0 0 1
                        1.06.031l7.743 7.883-7.742 7.42a.773.773 0
                         0 1-1.06 0 .697.697 0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
                          0 0 1 .032-1.016"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ) : showBlog == 'People @ SoulRooms' ? (
              <div className="flex justify-center py-12">
                <div
                  className="card border-none  lg:pb-6 md:pb-1 pb-3 p-0 
             px-0 flex flex-col justify-center items-center
             rounded-0 text-center"
                  style={{ width: '257px' }}>
                  <div
                    className="blog3 w-full "
                    style={{
                      background: `linear-gradient(rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.24) 100%)
                     , url(${'/static/images/landingPages/blog13.png'})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}></div>
                  <div className="flex flex-col md:px-0 px-4 lg:px-4 bg-white">
                    <p
                      className="m-0 pt-2 fs-14-16"
                      style={{
                        fontFamily: 'josefin Sans',
                        color: '#595959',
                      }}>
                      Februry, 6, 2021
                    </p>
                    <p
                      className="  overflow-hidden pt-0 m-0 lh-27  fs-22-24"
                      style={{
                        height: '109px',
                        fontFamily: 'josefin Sans',
                        color: '#1b1b1b',
                      }}>
                      Design Dreams
                    </p>
                    <div
                      className="flex justify-center mb-4
                  items-center md:pt-4 lg:pt-3 pt-2 lg:mt-0">
                      <a
                        href={'https://medium.com/@soulrooms_inc/design-dreams-7da99dc19b85'}
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none  link-warning fs-16-16 "
                        style={{
                          fontFamily: 'josefin Sans',
                          fontSize: '18px',
                          color: '#946F00',
                        }}>
                        Continue Reading
                      </a>
                      <svg
                        viewBox="0 0 24 24"
                        fill="#946F00"
                        width="1em"
                        height="1em"
                        data-ux="Icon"
                        data-aid="chevronRight"
                        className="x-el x-el-svg  link-warning fs-16-16">
                        <path
                          fillRule="evenodd"
                          d="M7.236 4.195a.773.773 0 0 1
                        1.06.031l7.743 7.883-7.742 7.42a.773.773 0
                         0 1-1.06 0 .697.697 0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
                          0 0 1 .032-1.016"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ) : showBlog == 'Roommates' ? (
              <div className="flex justify-center py-12">
                <div
                  className="card border-none  lg:pb-6 md:pb-1 pb-3 p-0 
           px-0 flex flex-col justify-center items-center
           rounded-0 text-center"
                  style={{ width: '257px' }}>
                  <div
                    className="blog3 w-full "
                    style={{
                      background: `linear-gradient(rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.24) 100%)
                   , url(${'/static/images/landingPages/blog4.png'})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}></div>
                  <div className="flex flex-col md:px-0 px-4 lg:px-4 bg-white">
                    <p
                      className="m-0 pt-2 fs-14-16"
                      style={{
                        fontFamily: 'josefin Sans',
                        color: '#595959',
                      }}>
                      June, 10, 2020
                    </p>
                    <p
                      className="  overflow-hidden pt-0 m-0 lh-27  fs-22-24"
                      style={{
                        height: '109px',
                        fontFamily: 'josefin Sans',
                        color: '#1b1b1b',
                      }}>
                      Make room for your roommates
                    </p>
                    <div
                      className="flex justify-center mb-4
                items-center md:pt-4 lg:pt-3 pt-2 lg:mt-0">
                      <a
                        href={'https://medium.com/soulrooms-inc/f-making-room-for-your-roommates-5a6d5d4519ff'}
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none  link-warning fs-16-16 "
                        style={{
                          fontFamily: 'josefin Sans',
                          fontSize: '18px',
                          color: '#946F00',
                        }}>
                        Continue Reading
                      </a>
                      <svg
                        viewBox="0 0 24 24"
                        fill="#946F00"
                        width="1em"
                        height="1em"
                        data-ux="Icon"
                        data-aid="chevronRight"
                        className="x-el x-el-svg  link-warning fs-16-16">
                        <path
                          fillRule="evenodd"
                          d="M7.236 4.195a.773.773 0 0 1
                      1.06.031l7.743 7.883-7.742 7.42a.773.773 0
                       0 1-1.06 0 .697.697 0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
                        0 0 1 .032-1.016"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ) : showBlog == 'Rooms for Rent' ? (
              <div className="flex justify-center py-12">
                <div
                  className="card border-none  lg:pb-6 md:pb-1 pb-3 p-0 
          px-0 flex flex-col justify-center items-center
          rounded-0 text-center"
                  style={{ width: '257px' }}>
                  <div
                    className="blog3 w-full "
                    style={{
                      background: `linear-gradient(rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.24) 100%)
                  , url(${'/static/images/landingPages/blog5.png'})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}></div>
                  <div className="flex flex-col md:px-0 px-4 lg:px-4 bg-white">
                    <p
                      className="m-0 pt-2 fs-14-16"
                      style={{
                        fontFamily: 'josefin Sans',
                        color: '#595959',
                      }}>
                      2021-06-14
                    </p>
                    <p
                      className="  overflow-hidden pt-0 m-0 lh-27  fs-22-24"
                      style={{
                        height: '109px',
                        fontFamily: 'josefin Sans',
                        color: '#1b1b1b',
                      }}>
                      How to Avoid Scams When Appartments
                    </p>
                    <div
                      className="flex justify-center mb-4
               items-center md:pt-4 lg:pt-3 pt-2 lg:mt-0">
                      <a
                        href={
                          'https://medium.com/soulrooms-inc/how-to-avoid-scams-when-apartment-shopping-99fe705efdb4'
                        }
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none  link-warning fs-16-16 "
                        style={{
                          fontFamily: 'josefin Sans',
                          fontSize: '18px',
                          color: '#946F00',
                        }}>
                        Continue Reading
                      </a>
                      <svg
                        viewBox="0 0 24 24"
                        fill="#946F00"
                        width="1em"
                        height="1em"
                        data-ux="Icon"
                        data-aid="chevronRight"
                        className="x-el x-el-svg  link-warning fs-16-16">
                        <path
                          fillRule="evenodd"
                          d="M7.236 4.195a.773.773 0 0 1
                     1.06.031l7.743 7.883-7.742 7.42a.773.773 0
                      0 1-1.06 0 .697.697 0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
                       0 0 1 .032-1.016"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ) : showBlog == 'Values' ? (
              <div className="flex justify-center py-12">
                <div
                  className="card border-none  lg:pb-6 md:pb-1 pb-3 p-0 
         px-0 flex flex-col justify-center items-center
         rounded-0 text-center"
                  style={{ width: '257px' }}>
                  <div
                    className="blog3 w-full "
                    style={{
                      background: `linear-gradient(rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.24) 100%)
                 , url(${'/static/images/landingPages/blog14.png'})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}></div>
                  <div className="flex flex-col md:px-0 px-4 lg:px-4 bg-white">
                    <p
                      className="m-0 pt-2 fs-14-16"
                      style={{
                        fontFamily: 'josefin Sans',
                        color: '#595959',
                      }}>
                      2021-06-14
                    </p>
                    <p
                      className="  overflow-hidden pt-0 m-0 lh-27  fs-22-24"
                      style={{
                        height: '109px',
                        fontFamily: 'josefin Sans',
                        color: '#1b1b1b',
                      }}>
                      The value system SoulRooms Practices in all our
                    </p>
                    <div
                      className="flex justify-center mb-4
              items-center md:pt-4 lg:pt-3 pt-2 lg:mt-0">
                      <a
                        href={
                          'https://medium.com/soulrooms-inc/the-value-system-soulrooms-practices-in-all-our-work-b0020ade51cc?source=rss----c8cd082290c1---4'
                        }
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none  link-warning fs-16-16 "
                        style={{
                          fontFamily: 'josefin Sans',
                          fontSize: '18px',
                          color: '#946F00',
                        }}>
                        Continue Reading
                      </a>
                      <svg
                        viewBox="0 0 24 24"
                        fill="#946F00"
                        width="1em"
                        height="1em"
                        data-ux="Icon"
                        data-aid="chevronRight"
                        className="x-el x-el-svg  link-warning fs-16-16">
                        <path
                          fillRule="evenodd"
                          d="M7.236 4.195a.773.773 0 0 1
                    1.06.031l7.743 7.883-7.742 7.42a.773.773 0
                     0 1-1.06 0 .697.697 0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
                      0 0 1 .032-1.016"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div
          className="container-fluid py-6 m-0 blog_section  "
          style={{
            background: `linear-gradient(rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%), url(${bg})`,
          }}>
          <div className="container mx-auto">
            <div className="row  pb-4">
              <div className="col-12   pt-3">
                <h3
                  className="uppercase fs-60 text-[44px] font-normal  text-center"
                  style={{ fontFamily: 'Fjalla One', color: '#ffffff' }}>
                  READ: SUGAR, SPICE AND ALL THINGS NICE…
                </h3>
              </div>
            </div>

            <div className="container text-base leading-[18px] text-center pt-7 " style={{ fontFamily: 'Josefin Sans' }}>
              <div className="">
                <div className="flex flex-col lg:flex-row justify-center ">
                  <div className="">
                    <a
                      onClick={() => {
                        setshowBlog('all-posts');
                      }}
                      className="blog_link ">
                      All Posts
                    </a>
                    <a
                      onClick={() => {
                        setshowBlog('Affordability');
                      }}
                      className="blog_link px-3">
                      Affordability
                    </a>
                  </div>

                  <div className="">
                    <a
                      onClick={() => {
                        setshowBlog('Collaboration');
                      }}
                      className="blog_link  ">
                      Collaboration
                    </a>

                    <a
                      onClick={() => {
                        setshowBlog('Environment');
                      }}
                      className="blog_link  px-3">
                      Environment
                    </a>
                  </div>

                  <div className="">
                    <a
                      onClick={() => {
                        setshowBlog('People @ SoulRooms');
                      }}
                      className="blog_link   ">
                      People @ SoulRooms
                    </a>
                    <a
                      onClick={() => {
                        setshowBlog('Roommates');
                      }}
                      className="blog_link px-3">
                      Roommates
                    </a>
                  </div>

                  <div className="">
                    <a
                      onClick={() => {
                        setshowBlog('Rooms for Rent');
                      }}
                      className="blog_link ">
                      Rooms for Rent
                    </a>
                    <a
                      onClick={() => {
                        setshowBlog('Values');
                      }}
                      className="blog_link  pl-2 lg:pl-3">
                      Values
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {showBlog == 'all-posts' ? (
              <BlogsSlider />
            ) : showBlog == 'Affordability' ? (
              <div className="flex justify-center py-12">
                <div
                  className="card border-none  lg:pb-6 md:pb-2 pb-4 p-0 
               px-0 flex flex-col justify-center items-center
               rounded-0 text-center"
                  style={{ width: '257px' }}>
                  <div
                    className="blog3 w-100 "
                    style={{
                      background: `linear-gradient(rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.24) 100%)
                       , url(${'/static/images/landingPages/blog1.png'})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}></div>
                  <div className="flex flex-col md:px-0 px-6 lg:px-4">
                    <p
                      className="m-0 pt-3 fs-14-16"
                      style={{
                        fontFamily: 'josefin Sans',
                        color: '#595959',
                      }}>
                      July 6, 2020
                    </p>
                    <p
                      className="  overflow-hidden pt-0 m-0 lh-27  fs-22-24"
                      style={{
                        height: '109px',
                        fontFamily: 'josefin Sans',
                        color: '#1b1b1b',
                      }}>
                      Let &apos;s talk about Toronto rent
                    </p>
                    <div
                      className="flex justify-center mb-4
                    items-center md:pt-4 lg:pt-3 pt-2 lg:mt-0">
                      <a
                        href={
                          'https://medium.com/soulrooms-inc/lets-talk-about-toronto-rent-2774e010876f?source=rss----c8cd082290c1---4'
                        }
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none  link-warning fs-16-16 "
                        style={{
                          fontFamily: 'josefin Sans',
                          fontSize: '18px',
                          color: '#946F00',
                        }}>
                        Continue Reading
                      </a>
                      <svg
                        viewBox="0 0 24 24"
                        fill="#946F00"
                        width="1em"
                        height="1em"
                        data-ux="Icon"
                        data-aid="chevronRight"
                        className="x-el x-el-svg  link-warning fs-16-16">
                        <path
                          fillRule="evenodd"
                          d="M7.236 4.195a.773.773 0 0 1
                          1.06.031l7.743 7.883-7.742 7.42a.773.773 0
                           0 1-1.06 0 .697.697 0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
                            0 0 1 .032-1.016"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ) : showBlog == 'Collaboration' ? (
              <div className="flex justify-center py-5">
                <div
                  className="card border-none  lg:pb-6 md:pb-1 pb-3 p-0 
              px-0 flex flex-col justify-center items-center
              rounded-0 text-center"
                  style={{ width: '257px' }}>
                  <div
                    className="blog3 w-full "
                    style={{
                      background: `linear-gradient(rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.24) 100%)
                      , url(${'/static/images/landingPages/blog3.png'})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}></div>
                  <div className="flex flex-col md:px-0 px-6 lg:px-4">
                    <p
                      className="m-0 pt-3 fs-14-16"
                      style={{
                        fontFamily: 'josefin Sans',
                        color: '#595959',
                      }}>
                      June, 20, 2020
                    </p>
                    <p
                      className="  overflow-hidden pt-0 m-0 lh-27  fs-22-24"
                      style={{
                        height: '109px',
                        fontFamily: 'josefin Sans',
                        color: '#1b1b1b',
                      }}>
                      Can co-living create the next big idea?
                    </p>
                    <div
                      className="flex justify-center mb-6
                   items-center md:pt-4 lg:pt-3 pt-2 lg:mt-0">
                      <a
                        href={'https://medium.com/soulrooms-inc/f-can-co-living-create-the-next-big-idea-73bc969430cf'}
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none  link-warning fs-16-16 "
                        style={{
                          fontFamily: 'josefin Sans',
                          fontSize: '18px',
                          color: '#946F00',
                        }}>
                        Continue Reading
                      </a>
                      <svg
                        viewBox="0 0 24 24"
                        fill="#946F00"
                        width="1em"
                        height="1em"
                        data-ux="Icon"
                        data-aid="chevronRight"
                        className="x-el x-el-svg  link-warning fs-16-16">
                        <path
                          fillRule="evenodd"
                          d="M7.236 4.195a.773.773 0 0 1
                         1.06.031l7.743 7.883-7.742 7.42a.773.773 0
                          0 1-1.06 0 .697.697 0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
                           0 0 1 .032-1.016"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ) : showBlog == 'Environment' ? (
              <div className="flex justify-center py-5">
                <div
                  className="card border-none  lg:pb-6 md:pb-2 pb-4 p-0 
             px-0 flex flex-col justify-center items-center
             rounded-0 text-center"
                  style={{ width: '257px' }}>
                  <div
                    className="blog3 w-100 "
                    style={{
                      background: `linear-gradient(rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.24) 100%)
                     , url(${'/static/images/landingPages/blog2.png'})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}></div>
                  <div className="flex flex-col md:px-0 px-6 lg:px-4">
                    <p
                      className="m-0 pt-2 fs-14-16"
                      style={{
                        fontFamily: 'josefin Sans',
                        color: '#595959',
                      }}>
                      June, 28, 2020
                    </p>
                    <p
                      className="  overflow-hidden pt-0 m-0 lh-27  fs-22-24"
                      style={{
                        height: '109px',
                        fontFamily: 'josefin Sans',
                        color: '#1b1b1b',
                      }}>
                      Want to support the enviourment?Try co-living.
                    </p>
                    <div
                      className="flex justify-center mb-4
                  items-center md:pt-4 lg:pt-3 pt-2 lg:mt-0">
                      <a
                        href={
                          'https://medium.com/soulrooms-inc/f-we-all-hear-about-climate-change-on-the-news-from-your-friends-a636c47eab60'
                        }
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none  link-warning fs-16-16 "
                        style={{
                          fontFamily: 'josefin Sans',
                          fontSize: '18px',
                          color: '#946F00',
                        }}>
                        Continue Reading
                      </a>
                      <svg
                        viewBox="0 0 24 24"
                        fill="#946F00"
                        width="1em"
                        height="1em"
                        data-ux="Icon"
                        data-aid="chevronRight"
                        className="x-el x-el-svg  link-warning fs-16-16">
                        <path
                          fillRule="evenodd"
                          d="M7.236 4.195a.773.773 0 0 1
                        1.06.031l7.743 7.883-7.742 7.42a.773.773 0
                         0 1-1.06 0 .697.697 0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
                          0 0 1 .032-1.016"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ) : showBlog == 'People @ SoulRooms' ? (
              <div className="flex justify-center py-5">
                <div
                  className="card border-none  lg:pb-6 md:pb-1 pb-4 p-0 
             px-0 flex flex-col justify-center items-center
             rounded-0 text-center"
                  style={{ width: '257px' }}>
                  <div
                    className="blog3 w-100 "
                    style={{
                      background: `linear-gradient(rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.24) 100%)
                     , url(${'/static/images/landingPages/blog13.png'})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}></div>
                  <div className="flex flex-col md:px-0 px-6 lg:px-4">
                    <p
                      className="m-0 pt-3 fs-14-16"
                      style={{
                        fontFamily: 'josefin Sans',
                        color: '#595959',
                      }}>
                      Februry, 6, 2021
                    </p>
                    <p
                      className="  overflow-hidden pt-0 m-0 lh-27  fs-22-24"
                      style={{
                        height: '109px',
                        fontFamily: 'josefin Sans',
                        color: '#1b1b1b',
                      }}>
                      Design Dreams
                    </p>
                    <div
                      className="flex justify-center mb-6
                  items-center md:pt-4 lg:pt-3 pt-2 lg:mt-0">
                      <a
                        href={'https://medium.com/@soulrooms_inc/design-dreams-7da99dc19b85'}
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none  link-warning fs-16-16 "
                        style={{
                          fontFamily: 'josefin Sans',
                          fontSize: '18px',
                          color: '#946F00',
                        }}>
                        Continue Reading
                      </a>
                      <svg
                        viewBox="0 0 24 24"
                        fill="#946F00"
                        width="1em"
                        height="1em"
                        data-ux="Icon"
                        data-aid="chevronRight"
                        className="x-el x-el-svg  link-warning fs-16-16">
                        <path
                          fillRule="evenodd"
                          d="M7.236 4.195a.773.773 0 0 1
                        1.06.031l7.743 7.883-7.742 7.42a.773.773 0
                         0 1-1.06 0 .697.697 0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
                          0 0 1 .032-1.016"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ) : showBlog == 'Roommates' ? (
              <div className="flex justify-center py-5">
                <div
                  className="card border-none  lg:pb-6 md:pb-1 pb-3 p-0 
           px-0 flex flex-col justify-center items-center
           rounded-0 text-center"
                  style={{ width: '257px' }}>
                  <div
                    className="blog3 w-100 "
                    style={{
                      background: `linear-gradient(rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.24) 100%)
                   , url(${'/static/images/landingPages/blog4.png'})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}></div>
                  <div className="flex flex-col md:px-0 px-4 lg:px-4 bg-white">
                    <p
                      className="m-0 pt-2 fs-14-16"
                      style={{
                        fontFamily: 'josefin Sans',
                        color: '#595959',
                      }}>
                      June, 10, 2020
                    </p>
                    <p
                      className="  overflow-hidden pt-0 m-0 lh-27  fs-22-24"
                      style={{
                        height: '109px',
                        fontFamily: 'josefin Sans',
                        color: '#1b1b1b',
                      }}>
                      Make room for your roommates
                    </p>
                    <div
                      className="flex justify-center mb-4
                items-center md:pt-4 lg:pt-3 pt-2 lg:mt-0">
                      <a
                        href={'https://medium.com/soulrooms-inc/f-making-room-for-your-roommates-5a6d5d4519ff'}
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none  link-warning fs-16-16 "
                        style={{
                          fontFamily: 'josefin Sans',
                          fontSize: '18px',
                          color: '#946F00',
                        }}>
                        Continue Reading
                      </a>
                      <svg
                        viewBox="0 0 24 24"
                        fill="#946F00"
                        width="1em"
                        height="1em"
                        data-ux="Icon"
                        data-aid="chevronRight"
                        className="x-el x-el-svg  link-warning fs-16-16">
                        <path
                          fillRule="evenodd"
                          d="M7.236 4.195a.773.773 0 0 1
                      1.06.031l7.743 7.883-7.742 7.42a.773.773 0
                       0 1-1.06 0 .697.697 0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
                        0 0 1 .032-1.016"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ) : showBlog == 'Rooms for Rent' ? (
              <div className="flex justify-center py-5">
                <div
                  className="card border-none  lg:pb-6 md:pb-1 pb-3 p-0 
          px-0 flex flex-col justify-center items-center
          rounded-0 text-center"
                  style={{ width: '257px' }}>
                  <div
                    className="blog3 w-100 "
                    style={{
                      background: `linear-gradient(rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.24) 100%)
                  , url(${'/static/images/landingPages/blog5.png'})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}></div>
                  <div className="flex flex-col md:px-0 px-4 lg:px-4 bg-white">
                    <p
                      className="m-0 pt-2 fs-14-16"
                      style={{
                        fontFamily: 'josefin Sans',
                        color: '#595959',
                      }}>
                      2021-06-14
                    </p>
                    <p
                      className="  overflow-hidden pt-0 m-0 lh-27  fs-22-24"
                      style={{
                        height: '109px',
                        fontFamily: 'josefin Sans',
                        color: '#1b1b1b',
                      }}>
                      How to Avoid Scams When Appartments
                    </p>
                    <div
                      className="flex justify-center mb-4
               items-center md:pt-4 lg:pt-3 pt-2 lg:mt-0">
                      <a
                        href={
                          'https://medium.com/soulrooms-inc/how-to-avoid-scams-when-apartment-shopping-99fe705efdb4'
                        }
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none  link-warning fs-16-16 "
                        style={{
                          fontFamily: 'josefin Sans',
                          fontSize: '18px',
                          color: '#946F00',
                        }}>
                        Continue Reading
                      </a>
                      <svg
                        viewBox="0 0 24 24"
                        fill="#946F00"
                        width="1em"
                        height="1em"
                        data-ux="Icon"
                        data-aid="chevronRight"
                        className="x-el x-el-svg  link-warning fs-16-16">
                        <path
                          fillRule="evenodd"
                          d="M7.236 4.195a.773.773 0 0 1
                     1.06.031l7.743 7.883-7.742 7.42a.773.773 0
                      0 1-1.06 0 .697.697 0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
                       0 0 1 .032-1.016"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ) : showBlog == 'Values' ? (
              <div className="flex justify-center py-5">
                <div
                  className="card border-none  lg:pb-6 md:pb-1 pb-3 p-0 
         px-0 flex flex-col justify-center items-center
         rounded-0 text-center"
                  style={{ width: '257px' }}>
                  <div
                    className="blog3 w-100 "
                    style={{
                      background: `linear-gradient(rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.24) 100%)
                 , url(${'/static/images/landingPages/blog14.png'})`,
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}></div>
                  <div className="flex flex-col md:px-0 px-4 lg:px-4 bg-white">
                    <p
                      className="m-0 pt-2 fs-14-16"
                      style={{
                        fontFamily: 'josefin Sans',
                        color: '#595959',
                      }}>
                      2021-06-14
                    </p>
                    <p
                      className="  overflow-hidden pt-0 m-0 lh-27  fs-22-24"
                      style={{
                        height: '109px',
                        fontFamily: 'josefin Sans',
                        color: '#1b1b1b',
                      }}>
                      The value system SoulRooms Practices in all our
                    </p>
                    <div
                      className="flex justify-center mb-4
              items-center md:pt-4 lg:pt-3 pt-2 lg:mt-0">
                      <a
                        href={
                          'https://medium.com/soulrooms-inc/the-value-system-soulrooms-practices-in-all-our-work-b0020ade51cc?source=rss----c8cd082290c1---4'
                        }
                        target="_blank"
                        rel="noreferrer"
                        className="text-decoration-none  link-warning fs-16-16 "
                        style={{
                          fontFamily: 'josefin Sans',
                          fontSize: '18px',
                          color: '#946F00',
                        }}>
                        Continue Reading
                      </a>
                      <svg
                        viewBox="0 0 24 24"
                        fill="#946F00"
                        width="1em"
                        height="1em"
                        data-ux="Icon"
                        data-aid="chevronRight"
                        className="x-el x-el-svg  link-warning fs-16-16">
                        <path
                          fillRule="evenodd"
                          d="M7.236 4.195a.773.773 0 0 1
                    1.06.031l7.743 7.883-7.742 7.42a.773.773 0
                     0 1-1.06 0 .697.697 0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
                      0 0 1 .032-1.016"></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      )}
      <Styles/>
    </>
  );
};

export default Blogs;
